
import { computed, defineComponent, watch } from "vue";

interface PasswordEvaluator {
  evalFunc: (password: string, confirmedPassword: string) => boolean;
  description: string;
}

interface PasswordEvaluationResult {
  isValid: boolean;
  evaluator: PasswordEvaluator;
}
export default defineComponent({
  props: {
    password: {
      required: true,
      type: String,
    },
    confirmPassword: {
      required: true,
      type: String,
    },
    value: {
      type: Boolean,
    },
  },
  emits: ["input"],
  setup(props, { emit }) {
    const passwordEvaluations: PasswordEvaluator[] = [
      {
        description: "Minimum of 8 characters",
        evalFunc: (p) => p.length >= 8,
      },
      {
        description: "Must contain a number",
        evalFunc: (p) => /\d/.test(p),
      },
      {
        description: "Must contain one uppercase letter",
        evalFunc: (p) => /[A-Z]/.test(p),
      },
      {
        description: "Must contain a special character",
        // eslint-disable-next-line no-useless-escape
        evalFunc: (p) => /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(p),
      },
      {
        description: "Your passwords must match",
        evalFunc: (p, cp) => !!p.length && p === cp,
      },
    ];

    const evaluationResults = computed<PasswordEvaluationResult[]>(() => {
      return passwordEvaluations.map((x) => ({
        evaluator: x,
        isValid: x.evalFunc(props.password, props.confirmPassword),
      }));
    });

    watch(
      evaluationResults,
      (results) =>
        emit(
          "input",
          results.every((x) => x.isValid)
        ),
      { immediate: true }
    );

    return { passwordEvaluations, evaluationResults };
  },
});
